export default __webpack_public_path__ + "static/Tek_Triangle_Ceiling-0fd90335d806946f2d772bfddf7f9df5.png";